/**
 * Portfolio Status types
 */ export var PortfolioItemStatus = /*#__PURE__*/ function(PortfolioItemStatus) {
    PortfolioItemStatus["Default"] = "Default";
    PortfolioItemStatus["NotStarted"] = "NotStarted";
    PortfolioItemStatus["OnTrack"] = "OnTrack";
    PortfolioItemStatus["AtRisk"] = "AtRisk";
    PortfolioItemStatus["OffTrack"] = "OffTrack";
    PortfolioItemStatus["Closed"] = "Closed";
    return PortfolioItemStatus;
}({});
/**
 * Portfolio Status type options
 */ export const PortfolioStatusTypeOptions = [
    "NotStarted",
    "OnTrack",
    "AtRisk",
    "OffTrack",
    "Closed"
];
/**
 * Portfolio item type
 */ export var PortfolioItemType = /*#__PURE__*/ function(PortfolioItemType) {
    /** Root portfolio item type */ PortfolioItemType["Portfolio"] = "Portfolio";
    /** Child portfolio item type */ PortfolioItemType["Project"] = "Project";
    return PortfolioItemType;
}({});
/**
 * Portfolio item sub type version
 */ export var PortfolioItemSubType = /*#__PURE__*/ function(PortfolioItemSubType) {
    /** Root portfolio item created from legacy roadmap experience */ PortfolioItemSubType["Roadmap"] = "Roadmap";
    /** Child portfolio item created from legacy roadmap experience */ PortfolioItemSubType["RoadmapRow"] = "RoadmapRow";
    /** Root portfolio item created from portfolio experience */ PortfolioItemSubType["Portfolio"] = "Portfolio";
    /** Child portfolio item created from portfolio experience */ PortfolioItemSubType["PortfolioRow"] = "PortfolioRow";
    return PortfolioItemSubType;
}({});
/**
 * Experience to be delivered to the user, based on user interaction with the portfolio.
 */ export var PortfolioExperienceType = /*#__PURE__*/ function(PortfolioExperienceType) {
    /**
     * Old item where upgrade experience needs to be shown
     * Roadmap Created before Portfolio release, service version value - V1
     */ PortfolioExperienceType["Legacy"] = "V1";
    /**
     * Old item that have been upgraded to new item
     * Roadmap Created before Portfolio release and upgraded after Portfolio release, service version value - V1V2
     */ PortfolioExperienceType["Migrated"] = "V1V2";
    /**
     * New item where no upgrade experience needs to be shown
     * Roadmap/Portfolio Created after Portfolio release, service version value - V2
     */ PortfolioExperienceType["Current"] = "V2";
    return PortfolioExperienceType;
}({});
